const COUNTRY_CODES_WITH_LEADING_ZERO = ["39"];

export const formatCountryCodeAndPhoneNumber = (
  countryCode: string,
  phoneNumber: string
) => {
  const shouldTrimLeadingZero =
    !COUNTRY_CODES_WITH_LEADING_ZERO.includes(countryCode);

  if (shouldTrimLeadingZero && phoneNumber.startsWith("0")) {
    return createFormattedPhoneNumber(countryCode, phoneNumber.slice(1));
  }

  return createFormattedPhoneNumber(countryCode, phoneNumber);
};

function createFormattedPhoneNumber(countryCode: string, phoneNumber: string) {
  return `(+${countryCode}) ${phoneNumber}`;
}
